function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs4437"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath18",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  id: "path16",
  d: "M0 850.4h850.4V0H0z"
})), /*#__PURE__*/React.createElement("font", {
  id: "FontID0",
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: 700,
  horizAdvX: 90,
  horizOriginX: 0,
  "horiz-origin-y": 0,
  vertAdvY: 90,
  vertOriginX: 45,
  vertOriginY: 90
}, /*#__PURE__*/React.createElement("fontFace", {
  id: "font-face7",
  fontFamily: "Arial Narrow"
}), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph13",
  horizAdvX: 228
}), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph15",
  horizAdvX: 500,
  unicode: "L"
}, /*#__PURE__*/React.createElement("path", {
  id: "path17",
  d: "M63 0v710h118.2V120.7H476V0H63z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph19",
  horizAdvX: 774,
  unicode: "W"
}, /*#__PURE__*/React.createElement("path", {
  id: "path21",
  d: "M142.5 0L2.5 715.8H124l87.8-491.6 107.5 491.6h141.2l103-500 90.3 500H773L630.3 0h-126L387.2 535.2 271 0H142.5z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph23",
  horizAdvX: 456,
  unicode: "k"
}, /*#__PURE__*/React.createElement("path", {
  id: "path25",
  d: "M55.2 0v715.8H168V336l131.3 182.5H438L292.5 329.2 448.2 0h-121L219.7 232.8 168 166V0H55.2z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph27",
  horizAdvX: 456,
  unicode: "e"
}, /*#__PURE__*/React.createElement("path", {
  id: "path29",
  d: "M305.7 165l111.8-22.8c-15-52.2-38.3-90.9-69.8-116-31.7-25.4-70-37.9-115.2-37.9-62.8 0-111.3 21-145.7 63-40.3 48.9-60.5 117.2-60.5 205 0 86.7 20.4 156 61 208 34.5 44 79.2 66 133.9 66 60.8 0 108.6-22.5 143.1-67.5 39.7-51.3 59.5-127.1 59.5-227.5l-.5-15.6H141.7c.6-41 9.8-72.7 27.5-95.2 17.8-22.5 39.1-33.7 64.1-33.7 36.2 0 60.4 24.7 72.4 74.2zm6.3 138.7c-1 40.3-9.7 70.8-25.8 91.1-16.4 20.4-35.7 30.5-58.2 30.5-23.7 0-43.8-10.6-60-31.8-16.7-21.5-24.8-51.3-24.5-89.8H312z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph31",
  horizAdvX: 500,
  unicode: "o"
}, /*#__PURE__*/React.createElement("path", {
  id: "path33",
  d: "M32.7 266.7c0 50.6 10.1 97 30.3 138.6 20.2 41.7 46.5 72.9 79.2 93.7A199.4 199.4 0 00252 530.3c68.3 0 122-26.8 161.2-80.3 39-53.7 58.5-116.2 58.5-187.8 0-53.4-10.2-101.5-30.5-144.5-20.4-43-47-75.4-80-96.9a194.6 194.6 0 00-108.7-32.5c-63.2 0-115.7 24-157.3 72.2-41.7 48.2-62.5 116.8-62.5 206.2zm115.3-7.4c0-52.5 10.2-92.1 30.7-119 20.5-26.8 45.3-40.1 74.3-40.1 28.3 0 52.5 13.5 72.7 40.5 20.1 27 30.3 66.8 30.3 119.6 0 51.4-10.3 90.5-30.8 117.7-20.5 27-45 40.5-73.7 40.5-28.3 0-52.7-13.5-73-40.5-20.3-27.2-30.5-66.7-30.5-118.7z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph35",
  horizAdvX: 456,
  unicode: "c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path37",
  d: "M429.7 365.2l-110.9-24.4c-8.1 54.4-33.6 81.5-76.6 81.5-27.7 0-50-11.6-66.9-35.1-17-23.4-25.5-63-25.5-118.7 0-61.5 8.5-105 25.5-130.3 16.9-25.4 39.5-38 67.9-38 21.1 0 38.5 7.1 52.1 21.6 13.9 14.5 23.5 40.2 29.4 76.9l110.8-22.9c-22.7-125-88.3-187.5-196.7-187.5-69.3 0-120.8 26.4-154.3 79C51 120.2 34.2 183.7 34.2 257.8c0 88.9 19 156.5 56.8 202.9 38 46.3 87.7 69.6 149.2 69.6 49.8 0 90.5-13.1 121.8-39.6 31.5-26.4 54-68.2 67.7-125.5z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph39",
  horizAdvX: 228,
  unicode: "i"
}, /*#__PURE__*/React.createElement("path", {
  id: "path41",
  d: "M59.2 588.8v127h112.6v-127H59.2zM59.2 0v518.5h112.6V0H59.2z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph43",
  horizAdvX: 500,
  unicode: "n"
}, /*#__PURE__*/React.createElement("path", {
  id: "path45",
  d: "M445.8 0H333v264.7c0 53-2.2 88.3-6.3 106a72.5 72.5 0 01-23.7 40.5 61 61 0 01-39.3 14.1c-18.9 0-36-6.1-51.4-18.3a97 97 0 01-32.1-50.5c-6.2-21.5-9.4-62-9.4-121.7V0H58.2v518.5h104.5v-76.2c18.5 29.4 39.3 51.4 62.6 66 23.4 14.7 49 22 77.4 22 33 0 60.6-8.6 83.3-25.6a131.5 131.5 0 0046.8-66c8.7-26.9 13-65.7 13-116.4V0z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph47",
  horizAdvX: 456,
  unicode: "a"
}, /*#__PURE__*/React.createElement("path", {
  id: "path49",
  d: "M143 360.3L41 382.8c12.3 52.4 32.8 90 61.3 113s69.4 34.5 122.9 34.5c47.5 0 83.8-6.6 108.8-20 25-13.5 43-31.5 53.7-54.5 10.8-23 16.1-64.6 16.1-125.3l-1-160.2c0-44.8 1.9-78.3 5.4-100.3a354.3 354.3 0 0120-70H316.8l-14.6 56.7a205.3 205.3 0 00-61.7-51.4c-22-11.3-45.3-17-70.2-17C129-11.7 95.2 2.2 68.8 30 42.5 57.8 29.3 94.8 29.3 141.2a173 173 0 0016 76.6c10.9 21.9 26 39.2 45.5 52.2s50.9 24.7 93.7 34.7c52.2 12 88.5 23.3 109 33.6 0 28.7-2 47.5-6.2 56.5a47 47 0 01-22.5 21.9c-10.8 5.8-26.1 8.6-46 8.6-20.3 0-36.1-4.6-47.6-13.6-11.5-9.2-21-26.2-28.2-51.4zM293.5 249a573.4 573.4 0 00-67-20.5c-34.8-9.2-57.5-19.2-68.3-30.3a59 59 0 01-16-42.9c0-19.8 5.8-36.6 17.6-50.1A57.3 57.3 0 01204.7 85c15.8 0 31.6 5.3 47.3 16.3a88.7 88.7 0 0132.5 38.9c6 15 9 42.1 9 81.5V249z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph51",
  horizAdvX: 500,
  unicode: "d"
}, /*#__PURE__*/React.createElement("path", {
  id: "path53",
  d: "M449.2 0h-105v76.2a184.5 184.5 0 00-61-65.9 134.1 134.1 0 00-72.2-22c-47.7 0-89 23.7-124.3 71-35.4 47.4-53 115-53 202.9 0 88.6 17.3 155.3 51.8 200.5 34.5 45 77 67.6 127.3 67.6 23.9 0 46-6 66.7-18.1a187 187 0 0057-54.2v257.8h112.7V0zM149 270.5c0-46.8 3.8-81.8 11.8-104.7 8-23 19.5-40.3 34.2-51.8a79.8 79.8 0 0150.2-17.3c24.6 0 46.1 13.3 64.3 40 18.3 26.6 27.3 67 27.3 120.6 0 59.5-8.8 102.5-26.5 128.7-17.8 26.2-40.3 39.3-67.6 39.3-26 0-48.2-12.8-66.4-38.6C158 361 149 322.3 149 270.5z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph55",
  horizAdvX: 318,
  unicode: "r"
}, /*#__PURE__*/React.createElement("path", {
  id: "path57",
  d: "M167 0H54.2v518.5h104.5v-73.7c18 34.5 34 57.4 48.1 68.7a77 77 0 0049 16.8c25.7 0 50.4-8.6 73.9-26l-35.2-119.5c-18.7 14.9-36.2 22.4-52.8 22.4a56.6 56.6 0 01-41.2-17.4c-12-11.5-20.5-32.3-25.7-62.6-5.1-30.4-7.8-86-7.8-167V0z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph59",
  horizAdvX: 272,
  unicode: "t"
}, /*#__PURE__*/React.createElement("path", {
  id: "path61",
  d: "M253.5 518.5V409.2h-76.7v-209c0-45.2 1-71.5 3.4-78.5C184.7 108.5 194 102 208 102c10.5 0 25.3 4.5 45 13.2l9.7-106.4a187.2 187.2 0 00-88.4-20.5c-28.6 0-51.6 6.9-68.8 20.5-17.3 13.7-28.8 33.4-34.7 59-4.6 19-6.8 57.4-6.8 115.4v226H12.2v109.3H64v103.2l112.8 80V518.5h76.7z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph63",
  horizAdvX: 638,
  unicode: "w"
}, /*#__PURE__*/React.createElement("path", {
  id: "path65",
  d: "M138.7 0L3.8 518.5h109.5l79.5-339.8 73.4 339.8h108.3l70.8-339.8 81.5 339.8h110.9L501 0H393l-73.2 333.5L247.5 0H138.7z"
})), /*#__PURE__*/React.createElement("glyph", {
  id: "glyph67",
  horizAdvX: 456,
  unicode: "y"
}, /*#__PURE__*/React.createElement("path", {
  id: "path69",
  d: "M5.3 518.5h120.2l101-368.2 99.7 368.2h116.1l-149.8-499-28.8-97.2c-12.7-36.5-25.4-63.1-37.9-80-12.5-17-28.5-30-47.8-39.1-19.3-9-43.2-13.7-71.5-13.7a250 250 0 00-64 8.3L32.7-94.7C50.3-99 66-101 80-101a71 71 0 0153 21.3c13.8 14.4 25.2 40.5 34 78.2L5.3 518.5z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "layer1",
  transform: "translate(-5.9 -271.7)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g10",
  transform: "matrix(.35278 0 0 -.35278 -40 525.6)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g12"
}, /*#__PURE__*/React.createElement("g", {
  id: "g14",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  clipPath: "url(#clipPath18)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path20",
  fill: "#1ab4d7",
  d: "M425 130.8a294 294 0 110 588 294 294 0 010-588"
}), /*#__PURE__*/React.createElement("path", {
  id: "path22",
  fill: "#fff",
  d: "M271.7 425.6l50.2 50.3a9 9 0 01-12.8 12.6l-50.1-50-50.4 50.1a9 9 0 11-12.6-12.8l50.1-50.1-50-50.2a9 9 0 016.2-15.4 9 9 0 016.3 2.6l50.3 50.2 50-50a9 9 0 1113 12.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path24",
  fill: "#fff",
  d: "M570 425.6a16.3 16.3 0 1132.6 0 16.3 16.3 0 01-32.7 0"
}), /*#__PURE__*/React.createElement("path", {
  id: "path26",
  fill: "#fff",
  d: "M539 425.6a47.4 47.4 0 1094.6 0 47.4 47.4 0 00-94.7 0m-18.6 0a66 66 0 11132 .2 66 66 0 01-132-.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "path28",
  fill: "#fff",
  d: "M515.6 490.4H513c-8.3 0-16.3-2.6-23-7.7a9 9 0 01-8.8 7c-5 0-8.9-4-8.9-8.9v-111a9 9 0 0118 0v68.3c0 22.7 2 31.9 21.6 34.3 1.8.3 3.7.2 3.7.2 5.4.2 9.2 3.9 9.2 8.8 0 5-4 9-9 9"
}), /*#__PURE__*/React.createElement("path", {
  id: "path30",
  fill: "#fff",
  d: "M343 436.5l.1.7a47.6 47.6 0 0092.5-.7zm111 1.7a65.8 65.8 0 11-128.5-29 66.4 66.4 0 0156-49.1 64.9 64.9 0 0143.4 10 70.7 70.7 0 0116.8 16l.4.3c3.5 4.4 2.9 10.7-1 13.7-3.4 2.6-9 3.6-13.3-2l-3.2-4.1a47.3 47.3 0 00-35-16 48.3 48.3 0 00-47.3 40.4H436c12.9.3 19.8 9.4 17.9 19.8"
})))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4443",
    viewBox: "0 0 208.2 208.2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.966751b4.svg";
export { ForwardRef as ReactComponent };